<script setup>
import { nextTick, ref } from 'vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';
import { ShieldCheck } from 'lucide-vue-next';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';

const recovery = ref(false);

const form = useForm({
    code: '',
    recovery_code: '',
});

// Dùng getElementById để focus (shadcn Input không forward ref tới DOM input).
const toggleRecovery = async () => {
    recovery.value = !recovery.value;

    await nextTick();

    if (recovery.value) {
        document.getElementById('recovery_code')?.focus();
        form.code = '';
    } else {
        document.getElementById('code')?.focus();
        form.recovery_code = '';
    }
};

const submit = () => {
    form.post(route('two-factor.login'));
};
</script>

<template>
    <Head title="Xác thực 2 lớp" />

    <div class="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-md">
            <CardHeader class="items-center space-y-3 text-center">
                <div class="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
                    <ShieldCheck class="h-6 w-6" />
                </div>
                <CardTitle class="text-2xl">Xác thực 2 lớp</CardTitle>
                <CardDescription>
                    <template v-if="! recovery">
                        Nhập mã xác thực từ ứng dụng authenticator của bạn.
                    </template>
                    <template v-else>
                        Nhập một trong các mã khôi phục khẩn cấp của bạn.
                    </template>
                </CardDescription>
            </CardHeader>

            <CardContent>
                <JetValidationErrors class="mb-4" />

                <form class="space-y-4" @submit.prevent="submit">
                    <div v-if="! recovery" class="space-y-2">
                        <Label for="code">Mã xác thực</Label>
                        <Input
                            id="code"
                            v-model="form.code"
                            type="text"
                            inputmode="numeric"
                            autofocus
                            autocomplete="one-time-code"
                        />
                    </div>

                    <div v-else class="space-y-2">
                        <Label for="recovery_code">Mã khôi phục</Label>
                        <Input
                            id="recovery_code"
                            v-model="form.recovery_code"
                            type="text"
                            autocomplete="one-time-code"
                        />
                    </div>

                    <Button
                        type="submit"
                        class="w-full"
                        :class="{ 'opacity-50': form.processing }"
                        :disabled="form.processing"
                    >
                        Đăng nhập
                    </Button>
                </form>

                <div class="mt-6 text-center text-sm">
                    <button
                        type="button"
                        class="text-muted-foreground hover:text-primary hover:underline"
                        @click.prevent="toggleRecovery"
                    >
                        <template v-if="! recovery">Dùng mã khôi phục</template>
                        <template v-else>Dùng mã xác thực</template>
                    </button>
                </div>
            </CardContent>
        </Card>
    </div>
</template>
